var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliateRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37435 7.08464C5.87012 7.08464 7.08268 5.87207 7.08268 4.3763C7.08268 2.88053 5.87012 1.66797 4.37435 1.66797C2.87858 1.66797 1.66602 2.88053 1.66602 4.3763C1.66602 5.87207 2.87858 7.08464 4.37435 7.08464Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 18.332C5.54673 18.332 6.66602 17.2127 6.66602 15.832C6.66602 14.4513 5.54673 13.332 4.16602 13.332C2.7853 13.332 1.66602 14.4513 1.66602 15.832C1.66602 17.2127 2.7853 18.332 4.16602 18.332Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 18.332C17.2147 18.332 18.334 17.2127 18.334 15.832C18.334 14.4513 17.2147 13.332 15.834 13.332C14.4533 13.332 13.334 14.4513 13.334 15.832C13.334 17.2127 14.4533 18.332 15.834 18.332Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.9743 13.3159C15.166 10.9992 12.9827 9.44088 10.5243 9.44088C10.516 9.44088 10.5077 9.44088 10.4993 9.44088L7.55768 9.44921C6.29102 9.46588 5.15768 8.60755 4.81602 7.37422V5.83255C4.81602 5.48255 4.53268 5.19922 4.17435 5.19922C3.81602 5.19922 3.54102 5.48255 3.54102 5.83255V15.1825C3.54102 15.5325 3.82435 15.8159 4.17435 15.8159C4.52435 15.8159 4.81602 15.5325 4.81602 15.1825V9.66589C5.54935 10.3159 6.50768 10.7159 7.54935 10.7159C7.55768 10.7159 7.55768 10.7159 7.56602 10.7159L10.5077 10.7076C10.516 10.7076 10.516 10.7076 10.5243 10.7076C12.4327 10.7076 14.141 11.9159 14.766 13.7242C14.8577 13.9909 15.1077 14.1492 15.366 14.1492C15.4327 14.1492 15.5077 14.1409 15.5743 14.1159C15.916 14.0159 16.091 13.6492 15.9743 13.3159Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateRequest);
export default __webpack_public_path__ + "static/media/affiliate-request.d14c701a3d0145b2f8068b4dbe4544cf.svg";
export { ForwardRef as ReactComponent };